var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    transform: "rotate(90 41.5 0.5)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 20.5,
    transform: "rotate(90 41.5 0.5)",
    stroke: "#E5E9F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 18.3334L25 21M25 21L22.3333 23.6667M25 21L17 21",
    stroke: "#0E0E0E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.3bbd3da7d8e3f87fc18ddff248758e31.svg";
export { ForwardRef as ReactComponent };